import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import Respostas from "@/pages/admin/Respostas";
import { pageHead } from "@/lib/seo";

const busca = z.object({
  filtro: z.enum(["todas", "nao-lidas", "sem-paciente"]).optional().catch(undefined),
  temperatura: z.enum(["quente", "morna", "fria"]).optional().catch(undefined),
});

// Layout do mestre-detalhe: a lista fica à esquerda e a resposta escolhida abre no <Outlet />.
export const Route = createFileRoute("/admin/formularios/$tipo")({
  validateSearch: busca,
  head: () => pageHead({ title: "Respostas | Painel", path: "/admin/formularios", noindex: true }),
  component: Respostas,
});
